import React from "react";

export default function LoadingComponent() {
  return (
    <div>
      <div>加载中...</div>
    </div>
  );
}
